// src/json/overlayData.json
export const overlaySectionWaterproofingSystems = {
    imageUrl: "/assets/imgs/services/12WaterproofingSystems/overlaySection/fondo.jpg",
    text: "The best Building Envelope Renewal /",
    highlight: "High-Rise Painting & Restoration services."
};
